<template>
    <div
        class="l-ss-c-completions-bar"
        :class="{ 'l-ss-c-completions-bar-not-empty': isVisibleShowAllButton }"
        @click="$emit('click', $event)"
        ref="completionsBar">
        <template v-if="isVisibleShowAllButton">
            <button
                v-if="isVisibleShowAllButton"
                class="l-ss-c-completions-show-all"
                @click="$emit('show-all-click', $event)">
                <span>
                    {{ $t('completions.showAll') }}
                </span>
                <i v-html="iconArrowRight"></i>
            </button>
        </template>
    </div>
</template>

<script>
    import iconArrowRight from '@/core/assets/images/icons/arrow-top.svg';

    export default {
        name: 'completions-bar',
        props: {
            isVisibleShowAllButton: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            iconArrowRight() {
                return iconArrowRight;
            },
        },
    };
</script>
